module.exports = __webpack_public_path__ + "img/Sin título_1.4.1.11711bf0.jpg";